<template>
    <div v-if="channel.pages" class="v-mainnav" :class="{ 'st-mainnav--slim': slimnavigation }">
		<ul class="st-mainnav" :class="{ 'st-mainnav--slim': slimnavigation }">
    		<li v-for="page in channel.pages" class="st-mainnav__item" :class="'st-mainnav__item--'+page.template">
				<router-link :to="page.url" class="st-mainnav__link st-mainnav__link--router" active-class="st-mainnav__link--current" exact-active-class="st-mainnav__link--exact">
					<i v-if="page.iconname" class="fa" :class="'fa-'+page.iconname"></i>
					<span class="st-mainnav__title">{{ $t(page.title) }}</span>
				</router-link>
				<ul v-if="page.actions" class="st-mainnav__submenu">
					<li v-for="action in page.actions" class="st-mainnav__item">
						<router-link :to="action.url" class="st-mainnav__link st-mainnav__link--router st-mainnav__link--subnav" exact-active-class="st-mainnav__link--exact">
							<i v-if="action.iconname" class="fa" :class="'fa-'+action.iconname"></i>
							<span v-if="action.i18n" class="st-mainnav__title">{{ $t(action.title, translate(action.i18n)) }}</span>
							<span v-else class="st-mainnav__title">{{ $t(action.title) }}</span>
						</router-link>
					</li>
				</ul>
    		</li>
    		<li v-if="channel.files && channel.files.length > 0">
    			<hr>
    		</li>
    		<li class="st-mainnav__item st-mainnav__item--open" v-if="(channel.files && channel.files.length > 0 || channel.page)">
    			<router-link v-if="channel.page" :to="'/panel/channel'" class="st-mainnav__link st-mainnav__link--router st-mainnav__link--subnav" exact-active-class="st-mainnav__link--exact">
    				<i class="fa fa-info"></i>
					<span class="st-mainnav__title">{{ $t('Infoguide') }}</span>
    			</router-link>
				<span v-else class="st-mainnav__el">
					<i class="fa fa-info"></i>
					<span class="st-mainnav__title">{{ $t('Infoguide') }}</span>
				</span>
    			<ul class="st-mainnav__submenu">
					<li  v-for="file in channel.files" class="st-mainnav__item">
						<a :href="file.url" download class="st-mainnav__link st-mainnav__link--subnav">
							<i v-if="file.icon" class="fa" :class="'fa-' + file.icon"></i>
							<span class="st-mainnav__title">{{ (file.description ? file.description : file.basename)}}</span>
						</a>
					</li>
				</ul>
			</li>
    	</ul>

		<transition
		name="mainnav-dev"
	    enter-active-class="animated fadeInUp"
	    leave-active-class="animated fadeOutDown">
	    	<ul v-if="devmode" class="st-mainnav" :class="{'st-mainnav--slim': slimnavigation }">
	    		<li class="st-mainnav__item">
					<router-link :to="{ name :'test' }" class="st-mainnav__link st-mainnav__link--router" active-class="st-mainnav__link--current" exact-active-class="st-mainnav__link--exact">
						<i class="fa fa-angellist"></i>
						<span class="st-mainnav__title">{{ $t('Test') }}</span>
					</router-link>
	    		</li>
	    		<li class="st-mainnav__item">
					<router-link :to="{ name :'settings' }" class="st-mainnav__link st-mainnav__link--router" active-class="st-mainnav__link--current" exact-active-class="st-mainnav__link--exact">
						<i class="fa fa-sliders"></i>
						<span class="st-mainnav__title">{{ $t('Settings') }}</span>
					</router-link>
	    		</li>
	    		<li class="st-mainnav__item">
					<router-link :to="{ name:'media_store' }" class="st-mainnav__link st-mainnav__link--router" active-class="st-mainnav__link--current" exact-active-class="st-mainnav__link--exact">
						<i class="fa fa-image"></i>
						<span class="st-mainnav__title">{{ $t('Media Store') }}</span>
					</router-link>
	    		</li>
	    		<li class="st-mainnav__item">
					<router-link :to="{ name:'styleguide' }" class="st-mainnav__link st-mainnav__link--router" active-class="st-mainnav__link--current" exact-active-class="st-mainnav__link--exact">
						<i class="fa fa-paint-brush"></i>
						<span class="st-mainnav__title">{{ $t('Styleguide') }}</span>
					</router-link>
	    		</li>
	    		<li class="st-mainnav__item">
					<router-link :to="{ name:'translations' }" class="st-mainnav__link st-mainnav__link--router" active-class="st-mainnav__link--current" exact-active-class="st-mainnav__link--exact">
						<i class="fa fa-flag"></i>
						<span class="st-mainnav__title">{{ $t('Translations') }}</span>
					</router-link>
	    		</li>
	    		<li v-if="channel.me.role === 'superuser'" class="st-mainnav__item">
					<a href="/processwire/" class="st-mainnav__link st-mainnav__link--router" active-class="st-mainnav__link--current" exact-active-class="st-mainnav__link--exact">
						<i class="fa fa-bug"></i>
						<span class="st-mainnav__title">{{ $t('Processwire') }}</span>
					</a>
	    		</li>
	    		<li>
					<div class="devmode devmode--block" v-if="devmode">
						<div v-if="loadings">
							<div v-for="(lstatestatus, lstatename) in loadings" v-if="lstatestatus">{{ lstatename }} <div class="inline-block spinner spinner--white spinner--large"></div></div>
						</div>
						{{ $t('DEV MODE') }}
					</div>
	    		</li>
	    	</ul>
    	</transition>
    </div>
</template>

<script>
import help_general from '@/helpers/general';

export default {
	name: 'v-mainnav',
	computed: {
		loadings(){
			return this.$store.getters.loadings;
		},
		devmode(){
			return this.$store.getters.devmode;
		},
		slimnavigation(){
			return this.$store.getters.slimnavigation;
		},
		channel(){
			return this.$store.getters.channel;
		}
	},
	methods: {
		...help_general
	}
}
</script>

<style scoped>

.st-mainnav__link--current + .st-mainnav__submenu {
	max-height: 500px;
}

.v-mainnav {
	display: flex;
	align-content: space-between;
	flex-flow: row wrap;
	height: 100%;
	/*overflow: scroll;*/
}

.st-mainnav {
	width: 100%;
}

.devmode--block {
	display: block;
	width: 100%;
	text-align: center;
	padding: .65em .90em;
}
</style>



// WEBPACK FOOTER //
// src/components/v-mainnav.vue